"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = exports.Tab = exports.TabList = exports.Tabs = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var focusRingStyles_1 = require("./focusRingStyles");
/**
 * A tabs component that allows users to switch between different views or panels.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Tabs.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-tabs--default}
 *
 * @example
 * ```tsx
 * <Tabs>
 *   <TabList>
 *     <Tab id="tab1">Tab 1</Tab>
 *     <Tab id="tab2">Tab 2</Tab>
 *     <Tab id="tab3">Tab 3</Tab>
 *   </TabList>
 *   <TabPanel id="tab1">Content for tab 1</TabPanel>
 *   <TabPanel id="tab2">Content for tab 2</TabPanel>
 *   <TabPanel id="tab3">Content for tab 3</TabPanel>
 * </Tabs>
 * ```
 *
 * @param isDisabled - Whether the TabList is disabled
 * @param disabledKeys - The item keys that are disabled
 * @param selectedKey - The currently selected key in the collection (controlled)
 * @param defaultSelectedKey - The initial selected key in the collection (uncontrolled)
 * @param keyboardActivation - Whether tabs are activated automatically on focus or manually. Defaults to 'automatic'
 * @param orientation - The orientation of the tabs. Defaults to 'horizontal'
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param onSelectionChange - Handler that is called when the selection changes
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Tabs = (0, styled_1.default)(react_aria_components_1.Tabs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap ", ";\n  &[data-orientation='horizontal'] {\n    flex-direction: column;\n    flex-grow: 1;\n  }\n"], ["\n  display: flex;\n  gap ", ";\n  &[data-orientation='horizontal'] {\n    flex-direction: column;\n    flex-grow: 1;\n  }\n"])), theme_1.theme.space.space16);
/**
 * A list of tabs that can be navigated using keyboard or mouse.
 *
 * @example
 * ```tsx
 * <TabList>
 *   <Tab id="tab1">Tab 1</Tab>
 *   <Tab id="tab2">Tab 2</Tab>
 * </TabList>
 * ```
 *
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param children - The contents of the collection. Can be ReactNode or a render function
 * @param dependencies - Values that should invalidate the item cache when using dynamic collections
 * @param items - Item objects in the collection
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
var StyledTabList = (0, styled_1.default)(react_aria_components_1.TabList)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap ", ";\n  overflow-x: auto;\n  border-bottom: ", " solid ", ";\n"], ["\n  display: flex;\n  gap ", ";\n  overflow-x: auto;\n  border-bottom: ", " solid ", ";\n"])), theme_1.theme.space.space8, theme_1.theme.borderWidths.regular, theme_1.theme.colors.borderNeutral);
var TabList = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(StyledTabList, __assign({}, props), children);
};
exports.TabList = TabList;
/**
 * A tab that can be selected to show its associated panel.
 * Can be used as a link or button depending on the props provided.
 *
 * @example
 * ```tsx
 * <Tab id="tab1" href="/section1">Tab Label</Tab>
 * ```
 *
 * @param id - The unique id of the tab
 * @param isDisabled - Whether the tab is disabled
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param href - A URL to link to
 * @param hrefLang - Hints at the human language of the linked URL
 * @param target - The target window for the link
 * @param rel - The relationship between the linked resource and the current page
 * @param download - Causes the browser to download the linked URL
 * @param ping - A space-separated list of URLs to ping when the link is followed
 * @param referrerPolicy - How much of the referrer to send when following the link
 * @param routerOptions - Options for the configured client side router
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Tab = (0, styled_1.default)(react_aria_components_1.Tab)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", " ", ";\n  cursor: default;\n  outline: none;\n  position: relative;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  forced-color-adjust: none;\n  color: ", ";\n  flex-shrink: 0;\n\n  &[data-hovered] {\n    background: ", ";\n    color: ", ";\n  }\n\n  &[data-selected] {\n    border-color: ", ";\n    border-bottom: 4px solid ", ";\n    color: ", ";\n    font-weight: ", ";\n    &[data-hovered] {\n      background: ", ";\n    }\n  }\n\n  &[data-disabled] {\n    opacity: ", ";\n  }\n\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: -2px;\n  }\n"], ["\n  padding: ", " ", ";\n  cursor: default;\n  outline: none;\n  position: relative;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  forced-color-adjust: none;\n  color: ", ";\n  flex-shrink: 0;\n\n  &[data-hovered] {\n    background: ", ";\n    color: ", ";\n  }\n\n  &[data-selected] {\n    border-color: ", ";\n    border-bottom: 4px solid ", ";\n    color: ", ";\n    font-weight: ", ";\n    &[data-hovered] {\n      background: ", ";\n    }\n  }\n\n  &[data-disabled] {\n    opacity: ", ";\n  }\n\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: -2px;\n  }\n"])), theme_1.theme.space.space8, theme_1.theme.space.space16, theme_1.theme.radii.field, theme_1.theme.radii.field, theme_1.theme.colors.contentTertiary, theme_1.theme.colors.bgScrimHovered, theme_1.theme.colors.contentPrimary, theme_1.theme.colors.borderNeutral, theme_1.theme.colors.bgPrimary, theme_1.theme.colors.contentPrimary, theme_1.theme.fontWeights.medium, theme_1.theme.colors.bgScrimHovered, theme_1.theme.opacity.semiOpaque, theme_1.theme.borderWidths.thick, theme_1.theme.colors.blue400);
/**
 * A panel that displays the content for its associated tab.
 * Can be mounted permanently or only when selected, with proper accessibility attributes.
 *
 * @example
 * ```tsx
 * <TabPanel
 *   shouldForceMount={true}
 *   id="panel1"
 *   aria-label="First tab panel"
 * >
 *   Panel content
 * </TabPanel>
 * ```
 *
 * @param shouldForceMount - Whether to mount the tab panel in the DOM even when not selected. Defaults to false
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param className - The CSS className for the element. Can be string or a function
 * @param style - The CSS styles for the element. Can be CSSProperties or a function
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.TabPanel = (0, styled_1.default)(react_aria_components_1.TabPanel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: ", ";\n  ", "\n"], ["\n  border-radius: ", ";\n  ", "\n"])), theme_1.theme.radii.card, focusRingStyles_1.FocusRingStyles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Tabs.js.map